module.exports = __webpack_public_path__ + "static/media/game-care.ff39dd1b.svg";